<div class="cancel-order" mat-dialog-content>
  <h3>Cancel Order</h3>
  <p *ngIf="(currentOrder$ | async) && !orderIds">
    Please select a reason for canceling load #{{ (currentOrder$ | async).loadNumber }}
  </p>
  <p *ngIf="orderIds">Please select a reason for canceling these orders</p>
  <div class="cancel-reason">
    <button
      mat-raised-button
      (click)="cancel('No longer needed')"
      saAutomatedSelector="lmo_orders_cancel_dialog__no_longer_needed"
    >
      No longer needed
    </button>
  </div>

  <div class="text-gray-600 text-xl border border-red-501 rounded m-3 p-3" *ngIf="skipLoaded">
    Note: Even if you selected loaded orders, those will not be canceled. They will be skipped and
    <strong class="text-gray-700">only unloaded orders will be cancelled.</strong>
  </div>

  <div class="cancel-reason" (click)="cancel('Well Down')">
    <button mat-raised-button>Well Down</button>
  </div>

  <div class="cancel-reason">
    <mat-form-field>
      <input matInput placeholder="Other reason" #other autocomplete="off" />
    </mat-form-field>
    <button mat-raised-button (click)="cancel(other.value)">{{ other.value ? other.value : 'Custom Reason' }}</button>
  </div>
</div>
